export const API_PATH_ApiDeviceMgmtLocationCreate = '/services/devices-mgtm/apiDeviceMgmtLocationCreate';
